export const ROLES = {
    COMPRAS: 'Compras',
    COMPRAS_SR: 'Compras Admin',
    RH: 'RH',
    CALIDAD: 'Calidad',
    AGENCIA: 'Agencia',
    PUBLIC: 'Public',
    LOGISTIC: 'Logistica Source Data',
    PROVEEDOR: 'Proveedor',
    PROVEEDOR_SD: 'Proveedor Source Data',
    PROVEEDOR_API: 'Proveedor API',
    OPERATIVO: 'Operativo',
    ADMINISTRATOR: 'Administrator'
};
